import React, { useState, useEffect } from "react";
import { Product } from "../../@types/Product";
import { useCart } from "../../contexts/CartContext";
import { toast } from "react-toastify";
import "./style/ProductCard.css";

const ProductCard: React.FC<{ product: Product }> = ({ product }) => {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [imagePath, setImagePath] = useState("http://localhost:3001");
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    setImagePath(process.env.REACT_APP_API_URL || "http://localhost:3001");
  }, []);

  useEffect(() => {
    if (product.image) {
      setImageUrl(`${imagePath}${product.image}`);
    } else {
      setImageUrl(`${imagePath}media/productImage/default.jpg`);
    }
  }, [product.image, imagePath]);

  const handleImageError = () => {
    setImageUrl(`${imagePath}media/productImage/default.jpg`);
  };

  const handleAddToCart = () => {
    if (quantity <= 0 || quantity > product.stock_quantity) {
      toast.error("Cantidad inválida o fuera de stock.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        style: { backgroundColor: "red", color: "white" },
      });
      return;
    }

    addToCart(product, quantity);

    toast.success(`Agregaste ${quantity} de ${product.name} al carrito`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      style: { backgroundColor: "green", color: "white" },
    });

    setQuantity(1);
  };

  const handleQuantityChange = (value: number) => {
    if (value > 0 && value <= product.stock_quantity) {
      setQuantity(value);
    } else {
      toast.warn("Cantidad no válida.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        style: { backgroundColor: "orange", color: "white" },
      });
    }
  };

  return (
    <div className="product-card">
      <img
        src={imageUrl}
        alt={product.name || "Imagen no disponible"}
        className="product-image"
        onError={handleImageError}
      />
      <h3 className="product-title">{product.name}</h3>
      <p className="product-price">Precio: ${product.regular_price}</p>
      <p className="product-stock">
        {product.stock_quantity > 0
          ? `Stock disponible: ${product.stock_quantity}`
          : "Producto agotado"}
      </p>
      <div className="product-action">
        <input
          type="number"
          value={quantity}
          min="1"
          max={product.stock_quantity}
          onChange={(e) => handleQuantityChange(Number(e.target.value))}
          className="quantity-input"
          disabled={product.stock_quantity === 0}
        />
        <button
          onClick={handleAddToCart}
          className="add-to-cart-button"
          disabled={product.stock_quantity === 0}
        >
          {product.stock_quantity === 0 ? "Sin Stock" : "Añadir"}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;